import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { CircularProgress } from '@mui/material';

interface props {
  heading?: string;
  text?: string;
}

const Loading = ({ heading = 'Loading', text = 'Please Wait...' }: props) => {
  return (
    <div>
      <Dialog aria-labelledby="customized-dialog-title" open={true}>
        <DialogContent dividers>
          <div style={{ textAlign: 'center', width: '300px' }}>
            <Typography gutterBottom>
              <CircularProgress color="primary" />
            </Typography>
            <Typography variant="h3" color={'secondary'} gutterBottom>
              {heading}
            </Typography>
            <Typography gutterBottom>{text}</Typography>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Loading;
